<template>
  <ExamUniformBatchDateRange date-key="examQuery"
                             v-bind="$attrs"
                             v-on="$listeners"></ExamUniformBatchDateRange>
</template>

<script>
import ExamUniformBatchDateRange from '../index'
export default {
  name: 'ExamUniformBatchExamQueryDate',
  components: {
    ExamUniformBatchDateRange
  }
}
</script>
